import { definePanel } from '@/app/definePanel';
import { VideoSearchIcon } from '@/components/occurra/icons/VideoSearchIcon';
import { PanelMode, PanelTheme } from '@/types/panels';

export default definePanel({
    id: 'video_search',
    title: 'Video search',
    description: 'Describe a scene. The archive answers with the moments that match.',
    icon: VideoSearchIcon,
    // A browse list like Objects and Events, not an elastic surface: it keeps
    // the width it was dragged to and the preview beside it does the filling.
    width: { min: 480, default: 480, max: Infinity, fill: false },
    modes: [PanelMode.View], // view-only — switching to settings auto-closes it
    themes: PanelTheme.Any,
    // Sits right after Events (4.3) in the nav — same "primary list" family as
    // Objects / Events. Mutual exclusion with those two lives in
    // src/app/exclusions.ts (group: video_search + camera_view + notifications).
    order: 4.4,
    // AI Search takes its place in the rail. The chat and the links of other panels still
    // open it.
    hasNavButton: false,
    // Scope the search to the camera selected elsewhere in the shell (cameras
    // panel, camera_view). Empty → search all cameras in the org.
    urlSyncedProps: ['cameraId'],
});
